export type TicketSource = "manual" | "automated" | "api";
export type TicketStatus = "open" | "closed" | "pending";
export type TicketPriority = "critical" | "high" | "medium" | "low";

// Single source of truth for how these enums read in the UI — the board
// columns, the ticket card, the details drawer and its Status/Priority
// controls all pull from these rather than each spelling out their own copy.
export const PRIORITY_LABELS: Record<TicketPriority, string> = {
  critical: "Overdue",
  high: "High Priority",
  medium: "Medium Priority",
  low: "Low Priority",
};

export const STATUS_LABELS: Record<TicketStatus, string> = {
  open: "To do",
  pending: "In Progress",
  closed: "Done",
};

// Model the synopsis endpoint is asked to use (POST /tickets/{id}/synopsis).
export const SYNOPSIS_MODEL = "google/gemini-2.5-flash-lite";

export const PRIORITY_TEXT_COLOR: Record<TicketPriority, string> = {
  critical: "text-orange-600 dark:text-orange-400",
  high: "text-rose-500 dark:text-rose-400",
  medium: "text-amber-500 dark:text-amber-400",
  low: "text-slate-500 dark:text-slate-400",
};

export interface TicketProps {
  id: string;
  tenant_id: string;
  conversation_id: string;
  tags: string[];
  source: TicketSource;
  status: TicketStatus;
  ticket_id: string;
  customer_name: string | null;
  customer_phone: string | null;
  customer_email: string | null;
  customer_city?: string | null;

  issue_type: string;
  issue_description: string | null;

  attachment_file_ids: string[];

  priority: TicketPriority;

  assigned_to_user_id: string | null;
  // Not confirmed on every ticket response yet — rendered only when present.
  assigned_at?: string | null;

  // AI synopsis — written by POST /tickets/{id}/synopsis, null until generated.
  synopsis?: string | null;
  synopsis_generated_at?: string | null;
  synopsis_model?: string | null;

  opened_at: string;
  resolved_at: string | null;

  resolution_note: string | null;

  created_at: string;
  updated_at: string;
}
